import { render } from "./ShopFilterSheetComponent.vue?vue&type=template&id=545c1696&scoped=true"
import script from "./ShopFilterSheetComponent.vue?vue&type=script&lang=js"
export * from "./ShopFilterSheetComponent.vue?vue&type=script&lang=js"

import "./ShopFilterSheetComponent.vue?vue&type=style&index=0&id=545c1696&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545c1696"]])

export default __exports__